module.exports = __webpack_public_path__ + "img/slide-history.abe24331.png";